import { Box, Heading, TextBlock } from "@bcc-ui/ui-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { ErasureIcon } from "components/icons/ErasureIcon";
import { LayeredLevels } from "components/icons/LayeredLevels";
import { RoundTick } from "components/icons/RoundTick";
import { CertifiedBadge } from "components/reports/passports/card/CertifiedBadge";
import style from "components/reports/passports/passports-view.scss";
import { getDiagnosticStatus, isPass, Panel } from "components/reports/passports/utils/Panel";
import { getPassportHeading, getPassportIdentifiers } from "components/reports/passports/utils/passportDisplay";
import { PublicPassportReport } from "services/report/passports/PassportService";
import { useTheme } from "utils/useTheme";

interface Props {
    report: PublicPassportReport;
}

export const PublicPassportResultCard = (props: Props) => {
    const { report } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    const na = t("Common.na");

    const heading = getPassportHeading(report.device_information) ?? na;
    const identifiers = getPassportIdentifiers(t, report.device_information, report.last_processed);

    return (
        <Box paddingBottom="Md" paddingTop="Xxs" columnLayout gap="Xxxs" className={style.resultCard}>
            <Heading tag="div" variant="h2" disableTopSpacing disableBottomSpacing className={style.resultModel}>
                {heading}
            </Heading>
            <Box
                justifyContent="SpaceBetween"
                verticalAlignment="Center"
                gap="Sm"
                className={style.resultIdentifiers}
                marginBottom="Md"
            >
                <Box gap="Sm">
                    {identifiers.map((id) => (
                        <TextBlock key={id} disableBottomSpacing>
                            {id}
                        </TextBlock>
                    ))}
                </Box>
                <CertifiedBadge />
            </Box>
            <Box gap="Md" marginTop="Md" className={style.sharedPanelsRow}>
                <Panel
                    title={t("DevicePassport.panel.clearance.title")}
                    description={t("DevicePassport.panel.clearance.description")}
                    status={getDiagnosticStatus(isPass(report.clearance), t)}
                    icon={<LayeredLevels color={theme.linkTextColor} />}
                />
                <Panel
                    title={t("DevicePassport.panel.diagnostic.title")}
                    description={t("DevicePassport.panel.diagnostic.description")}
                    status={getDiagnosticStatus(isPass(report.diagnostic_result), t)}
                    icon={<RoundTick color={theme.accordianSuccessTextColor} />}
                />
                <Panel
                    title={t("DevicePassport.panel.erasureDetails.title")}
                    description={t("DevicePassport.panel.erasureDetails.description")}
                    status={getDiagnosticStatus(isPass(report.erasure_result), t)}
                    icon={<ErasureIcon />}
                />
            </Box>
        </Box>
    );
};
